import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { renderSurfaceKind, isCompiledSurfaceKind }
  from "%/dynamic-component-editor/helpers/context-error-report";
import { resolveBoundEntityId } from "%/dynamic-component-editor/helpers/bound-context-entity-id";
import { useStoryStore } from "%/dynamic-component-editor/stores/story-store";
import { useStoryCommentsStore } from "%/dynamic-component-editor/stores/story-comments-store";
import { commentsAreFolded } from "%/dynamic-component-editor/helpers/story-comments.mjs";

const STORY_ID_IN_PATH = /\/[^/]+\/(\d+)\/?$/;
const MSG_NO_POST = "A comment element is on a page that shows no post, so it has no comments to show or take;"
  + " put it on a page or component that shows a post";

export const CommentsWidgetElementMixin = {
  extends: DynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    scopedProvidedContexts: { default: null },
    useExampleData: { default: () => () => false },
    inFeedRow: { default: false },
  },
  data() {
    return {
      resolvedUrlStoryId: 0,
    };
  },
  created() {
    if (this.showsSampleComments || typeof window === "undefined") {
      return;
    }
    const injectedStoryId = window.blclient?.data?.readerStoryId;
    if (injectedStoryId) {
      this.resolvedUrlStoryId = Number(injectedStoryId);
    } else {
      const match = window.location.pathname.match(STORY_ID_IN_PATH);
      if (match) {
        this.resolvedUrlStoryId = Number(match[1]);
      }
    }
    if (!this.storyEntityId) {
      // eslint-disable-next-line no-console
      console.error(MSG_NO_POST, { elementType: this.$options.name, path: window.location.pathname });
      return;
    }
    useStoryStore().getOrFetchStory(this.storyEntityId);
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    showsSampleComments() {
      return Boolean(this.editMode || this.isPreviewMode) || !isCompiledSurfaceKind(renderSurfaceKind());
    },
    storyEntityId() {
      return Number(resolveBoundEntityId(this, "story", () => this.resolvedUrlStoryId)) || 0;
    },
    storyComments() {
      return useStoryCommentsStore();
    },
    commentsFolded() {
      return commentsAreFolded({ inFeedRow: this.inFeedRow, editMode: this.showsSampleComments });
    },
  },
  methods: {
    getExampleEntity() {
      return {};
    },
    async getRealEntity() {
      return {};
    },
  },
};
